import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";

import "./ErrorMessage.scss";

const ErrorMessage = ({ children }) => (
	<div className="messages-error">
		<div className="messages-error-container">
			<div className="messages-error-text">
				{children || <Str>Oops! We couldn’t load your messages.</Str>}
			</div>

			<div className="messages-error-buttons">
				<button className="green flatbutton" onClick={() => window.location.reload()}>
					<Str>Reload</Str>
				</button>
			</div>
		</div>
	</div>
);

ErrorMessage.propTypes = {
	children: PropTypes.node,
};

ErrorMessage.defaultProps = {
	children: null,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/apps/messages/components/ErrorMessage.jsx